import React from "react";
import "../styles/common.css";

/**
 * Composant réutilisable pour le conteneur de page avec fond wave
 * @param {ReactNode} children - Le contenu de la page
 * @param {string} className - Classes CSS additionnelles
 */
export default function PageContainer({ children, className = "" }) {
  return (
    <div className={`page-container ${className}`}>
      {children}
    </div>
  );
}

